module.exports = __webpack_public_path__ + "static/media/02.76ba505b.mp3";